module.exports = __webpack_public_path__ + "static/LOGOPWAweb-36f7e2dedbbc73dce37ef1ea26a434e3.png";